// src/components/ui/Skeleton.tsx
import React from 'react';

export default function Skeleton({ className = '', style }: { className?: string; style?: React.CSSProperties }) {
  return <div className={`animate-pulse bg-[var(--surface-muted)] rounded ${className}`} style={style} />;
}
